import React, { useEffect, useMemo } from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getRoleRequest } from '../../containers/Auth/actions';
import { RootState } from '../../../../rootReducer';
import { RoleValues, routes } from '../../../../entities/Roles';

interface Props extends RouteProps {
  roles: RoleValues[] | '';
}

export const PrivateRoute: React.FC<Props> = ({ component: Component, ...rest }) => {
  const dispatch = useDispatch();
  const { role, loading } = useSelector((state: RootState) => state.authModuleReducer.authReducer);
  const { roles } = useSelector((state: RootState) => state.commonReducer.logoutReducer);
  const isMatchRole = useMemo(() => {
    if (role === null) return false;
    if (role.id === 5) return true;

    if (roles && roles.length !== 0) {
      if (roles.length > 1) return true;
    }

    return rest.roles.includes(role.name);
  }, [role, rest.roles]);

  useEffect(() => {
    if (role === null && !loading) dispatch(getRoleRequest());
  }, [role]);

  if (!Component || role === null) return null;

  return (
    <Route
      {...rest}
      render={(routeProps) =>
        isMatchRole ? (
          <Component {...routeProps} />
        ) : (
          <Redirect
            to={{
              pathname: role.name !== undefined ? routes[role.name as keyof typeof routes] : '/role-undefined',
              state: { from: routeProps.location },
            }}
          />
        )
      }
    />
  );
};
